import React from 'react';

export const CompanyName = ({ className = '' }) => <h3 className={className}>Company Name</h3>;
